// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OAuQ","field":"styles_field__3PEpf","fieldCol":"styles_fieldCol__EOFSb","diffCol":"styles_diffCol__3B7mw","diff":"styles_diff__3S1r-"};